import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommentListingDelivery from "../../CoreComponents/CommentListingDelivery";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import EditTopComponent from "../../CoreComponents/EditTopComponent";
import EditBottomComponent from "../../CoreComponents/EditBottomComponent";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ToggleButton from "../../CoreComponents/ToggleButton";

import {
  ManageDeliveryBoy,
  ManageDeliveryBoys,
  AccountTransactions,
  showMessage,
  GetDeliveryBoys,
} from "../../Functionalities/Functions";

import { ManageDeliveryBoyReviews } from "./Logic";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import { is_accountant_only, url, token } from "../../Functionalities/Config";
import RiderReport from "./RiderReport";
import axios from "axios";

function Body() {
  const { id } = useParams();

  const [data, setData] = useState({
    balance: 0,
    display_balance: 0,
    delivery_charge_balance: 0,
    display_delivery_charge_balance: 0,
    get_desc: "",
    details: "",
    is_approved: false,
    is_blocked: false,
    mobile: "",
    email: "",
    first_name: "",
    address1: "",
    id: "",
    is_delivery_boy: false,
    username: "",
    keyword: "",
    password: "",
    confirm_password: "",
    is_blocked1: false,
    deliveryboy_limit: "",
    cod_limit: "",
    cash_in_hand: 0,
  });

  const [reviews, setReviews] = useState([]);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getData();
    getReviews();
  }, []);
  const getReviews = () => {
    let params = "del_id=" + id;
    let result = ManageDeliveryBoyReviews("", "", "get", params);
    result.then((result) => {
      setReviews(result.data.results);
    });
  };

  const [noData, setNoData] = useState(false);

  const getData = () => {
    let params = "user_id=" + id;
    let result = ManageDeliveryBoy("", "get", "", params);

    result.then((result) => {
      var del_data = result.data.results[0];
      if (result.data.results.length > 0) {
        setData({
          ...data,
          id: del_data.id,
          display_balance: del_data.balance.balance,
          balance: del_data.balance.balance,

          display_delivery_charge_balance:
            del_data.delivery_charge_balance.balance,
          delivery_charge_balance: del_data.delivery_charge_balance.balance,

          details: "",
          is_approved: del_data.details.is_approved,
          is_blocked: del_data.details.is_blocked,
          mobile: del_data.details.mobile,
          email: del_data.email,
          first_name: del_data.first_name,
          user_id: del_data.id,
          is_delivery_boy: del_data.is_delivery_boy,
          username: del_data.username,
          address1: del_data.address.length && del_data.address[0].address1,
          is_blocked1: del_data.is_blocked,
          deliveryboy_limit: del_data.deliveryboy_limit,
          cod_limit: del_data.cod_limit ?? "",
          cash_in_hand: del_data.balance?.balance ?? 0,
        });
        setLoading(false);
      } else {
        setNoData(true);
        setLoading(false);
      }
    });
  };


  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">
          {!loading ? (
            !noData ? (
              <>
                <EditTopComponent
                  BackButtonPath={"/delivery-boys/"}
                  DeleteButton={(e) => {
                    e.preventDefault();
                    // if (window.confirm("Are You sure")) {
                    // }

                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div
                            className="custom-ui"
                            style={{
                              borderRadius: 8,
                              border: "solid",
                              padding: 70,
                              borderWidth: 0.5,
                            }}
                          >
                            <h1>Are you sure?</h1>
                            <p>You want to delete ?</p>
                            <button
                              onClick={onClose}
                              className="btn btn-primary"
                              style={{ marginRight: 10 }}
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => {
                                let result = ManageDeliveryBoys(
                                  e,
                                  "delete",
                                  "",
                                  `user_id=${data.id}`
                                );
                                result
                                  .then((result) => {
                                    if (result.data.Status === true) {
                                      showMessage(
                                        "Delete success",
                                        "success",
                                        "Success!",
                                        "top",
                                        "top-right"
                                      );
                                      window.location.replace("/delivery-boys");
                                    } else {
                                      // alert("error");
                                      // void 0
                                      showMessage(
                                        result.data.Error,
                                        "danger",
                                        "Failed!",
                                        "top",
                                        "top-right"
                                      );
                                    }
                                  })
                                  .catch((err) => {
                                    showMessage(
                                      "delete failed",
                                      "danger",
                                      "Error!",
                                      "top",
                                      "top-right"
                                    );
                                  });
                              }}
                              className="btn btn-primary"
                            >
                              Delete
                            </button>
                          </div>
                        );
                      },
                    });
                  }}
                  AddButtonName={"Add Delivery Boys"}
                  AddButtonPath={"/addboy"}
                  CancelButton={(e) => {
                    e.preventDefault();
                    setEdit(false);
                    // void 0
                  }}
                  EditButton={(e) => {
                    e.preventDefault();
                    setEdit(true);
                    // void 0
                  }}
                  Edit={edit}
                />

                <>
                  <div className="row">
                    <div className="col-xl-6 col-xxl-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="basic-form">
                            <form>
                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  First Name <span className="required">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled={!edit}
                                    value={data.first_name}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        first_name: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  Username <span className="required">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="text"
                                    disabled={!edit}
                                    className="form-control"
                                    value={data.username}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        username: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  Password
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="password"
                                    disabled={!edit}
                                    className="form-control"
                                    value={data.password}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        password: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              {data.password !== "" && (
                                <div className="form-group row">
                                  <label className="col-sm-4 col-form-label">
                                    Confirm Password
                                    <span className="required">*</span>
                                  </label>
                                  <div className="col-sm-8">
                                    <input
                                      type="password"
                                      className="form-control"
                                      value={data.confirm_password}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          confirm_password: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              )}

                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  Email
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="email"
                                    disabled={!edit}
                                    className="form-control"
                                    value={data.email}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        email: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  Mobile <span className="required">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    //    type="text" className="form-control"
                                    type="number"
                                    disabled={!edit}
                                    onKeyDown={(evt) =>
                                      ((evt.key === "e" ||
                                        evt.key === "-" ||
                                        evt.key === ".") &&
                                        evt.preventDefault()) ||
                                      (evt.key === "E" && evt.preventDefault())
                                    }
                                    onWheelCapture={(e) => {
                                      e.target.blur();
                                    }}
                                    min={0}
                                    className="form-control"
                                    value={data.mobile}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        mobile: e.target.value.slice(0, 10),
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <div className="form-group row">
                                <label className="col-sm-4 col-form-label">
                                  Address <span className="required">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled={!edit}
                                    value={data.address1}
                                    onChange={(e) =>
                                      setData({
                                        ...data,
                                        address1: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <br />

                              {!is_accountant_only && (
                              <div className="form-group row">
                                <div className="col-sm-3">Blocked</div>
                                <div className="col-sm-8">
                                  <div className="form-check">
                                    <ToggleButton
                                      inactiveLabel={""}
                                      activeLabel={""}
                                      colors={{
                                        activeThumb: {
                                          base: "#ED3833",
                                        },
                                        inactiveThumb: {
                                          base: "#51B04A",
                                        },
                                      }}
                                      checked={data.is_blocked1}
                                      value={data.is_blocked1 || false}
                                      // checked={restaurant.is_featured}
                                      thumbStyle={{ borderradius: 5 }}
                                      trackStyle={{ borderradius: 5 }}
                                      onToggle={(e) => {
                                        // void 0
                                        setData({ ...data, is_blocked1: !e });
                                        var x = {
                                          ...data,
                                          is_blocked1: !e,
                                          id: data.id,
                                        };
                                        let result = GetDeliveryBoys(
                                          e,
                                          "patch",
                                          x,
                                          ""
                                        );
                                        result
                                          .then((result) => {
                                            if (result.data.Status === true) {
                                              showMessage(
                                                "Delivery boy updated",
                                                "success",
                                                "Success!",
                                                "top",
                                                "top-right",
                                                0
                                              );
                                              // window.location.reload();
                                            } else {
                                              confirmAlert({
                                                customUI: ({ onClose }) => {
                                                  return (
                                                    <div
                                                      className="custom-ui"
                                                      style={{
                                                        borderRadius: 8,
                                                        border: "solid",
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItems: "center",
                                                        padding: 50,
                                                        borderWidth: 0.5,
                                                      }}
                                                    >
                                                      <div
                                                        style={{ width: "70%" }}
                                                      >
                                                        <h4>
                                                          {result.data.Error}
                                                        </h4>

                                                        {/* showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0) */}
                                                        <button
                                                          onClick={() => {
                                                            onClose();
                                                            window.location.reload();
                                                          }}
                                                          className="btn btn-primary"
                                                          style={{
                                                            marginRight: 10,
                                                          }}
                                                        >
                                                          Cancel
                                                        </button>
                                                        <button
                                                          onClick={() => {
                                                            window.location.reload();
                                                          }}
                                                          className="btn btn-primary"
                                                        >
                                                          OK
                                                        </button>
                                                      </div>
                                                    </div>
                                                  );
                                                },
                                              });
                                            }
                                          })
                                          .catch((error) => {
                                            // void 0
                                          });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              )}

                              {edit && (
                                <EditBottomComponent
                                  cancelButton={(e) => {
                                    e.preventDefault();
                                    setEdit(false);
                                  }}
                                  saveButton={(e) => {
                                    e.preventDefault();
                                    if (data.first_name === "") {
                                      showMessage(
                                        "Name is required",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }
                                    if (data.username === "") {
                                      showMessage(
                                        "Name is required",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    if (
                                      data.password !== data.confirm_password
                                    ) {
                                      showMessage(
                                        "Passwords do not match",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top - right",
                                        0
                                      );
                                      return;
                                    }
                                    if (
                                      data.password !== "" &&
                                      data.password.length < 5
                                    ) {
                                      showMessage(
                                        "Passwords must be more than 5 characters",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top - right",
                                        0
                                      );
                                      return;
                                    }

                                    if (data.mobile === "") {
                                      showMessage(
                                        "Mobile is required",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    if (data.mobile.includes(".")) {
                                      showMessage(
                                        "Invalid mobile number",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    if (data.mobile.length < 10) {
                                      showMessage(
                                        "Mobile numbers should be 10 ",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );

                                      return;
                                    }
                                    if (data.address1 === "") {
                                      showMessage(
                                        "Address is required",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    // alert('clicked')

                                    let result = ManageDeliveryBoy(
                                      e,
                                      "update",
                                      data,
                                      ""
                                    );
                                    result
                                      .then((result) => {
                                        if (result.data.Status === true) {
                                          // alert("success");
                                          showMessage(
                                            "Delivery boy updated",
                                            "success",
                                            "Success!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                          window.location.reload();
                                        } else {
                                          showMessage(
                                            result.data.Error,
                                            "danger",
                                            "danger!",
                                            "top",
                                            "top-right",
                                            0
                                          );

                                          showMessage(
                                            "Failed to save",
                                            "danger",
                                            "danger!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                        }
                                      })
                                      .catch((err) => {
                                        showMessage(
                                          "Error",
                                          "danger",
                                          "Error!",
                                          "top",
                                          "top-right",
                                          0
                                        );
                                      });

                                    setEdit(false);
                                  }}
                                />
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-xxl-6">
                      <div
                        style={{ backgroundColor: "white", borderRadius: 20 }}
                      >
                        <div className="card-body">
                          <p className="text-muted mb-3">
                            Cash the rider pays you is recorded under Previous settlements below, with the
                            mode, the account and who collected it.
                          </p>
                          <div className="basic-form">
                            <div className="card-header mb-2">
                              <h4 className="card-title">Balance to Pay</h4>
                            </div>

                            <div className="basic-form mb-2">
                              <form>
                                <div className="form-row mb-2">
                                  <div className="form-group col-md-6">
                                    <label>Balance Amount</label>
                                    <input
                                      type="number"
                                      min={0}
                                      onKeyDown={(evt) =>
                                        ((evt.key === "e" || evt.key === "-") &&
                                          evt.preventDefault()) ||
                                        (evt.key === "E" &&
                                          evt.preventDefault())
                                      }
                                      onWheelCapture={(e) => {
                                        e.target.blur();
                                      }}
                                      value={data.delivery_charge_balance}
                                      onChange={(e) => {
                                        setData({
                                          ...data,
                                          delivery_charge_balance:
                                            e.target.value,
                                        });
                                      }}
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="form-group col-md-6">
                                    <label>Description</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={data.get_desc}
                                      onChange={(e) => {
                                        setData({
                                          ...data,
                                          get_desc: e.target.value,
                                        });
                                      }}
                                    />
                                  </div>
                                </div>

                                <button
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (
                                      data.delivery_charge_balance === "" ||
                                      data.delivery_charge_balance === 0
                                    ) {
                                      showMessage(
                                        "Please enter a balance amount to pay",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }
                                    confirmAlert({
                                      customUI: ({ onClose }) => {
                                        return (
                                          <div
                                            className="custom-ui"
                                            style={{
                                              borderRadius: 8,
                                              border: "solid",
                                              padding: 70,
                                              borderWidth: 0.5,
                                            }}
                                          >
                                            <h3>
                                              Are you sure to pay ₹
                                              {data.delivery_charge_balance} to{" "}
                                              {data.first_name} ?
                                            </h3>
                                            <p>Click pay to continue</p>

                                            <button
                                              onClick={onClose}
                                              className="btn btn-primary"
                                              style={{ marginRight: 10 }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              onClick={() => {
                                                onClose();

                                                setData({
                                                  ...data,
                                                  keyword: "delivery_balance",
                                                });
                                                // void 0
                                                var sendData = {
                                                  ...data,
                                                  keyword: "delivery_balance",
                                                };
                                                let result =
                                                  AccountTransactions(
                                                    e,
                                                    sendData,
                                                    "add",
                                                    ""
                                                  );
                                                result.then((result) => {
                                                  if (
                                                    result.data.Status === true
                                                  ) {
                                                    showMessage(
                                                      "Data updated",
                                                      "success",
                                                      "Success!",
                                                      "top",
                                                      "top-right",
                                                      0
                                                    );
                                                    // window.location.reload();
                                                    onClose();
                                                  } else {
                                                    showMessage(
                                                      result.data.Error,
                                                      "danger",
                                                      "Failed!",
                                                      "top",
                                                      "top-right",
                                                      0
                                                    );
                                                    // window.location.reload();

                                                    onClose();
                                                  }
                                                });
                                              }}
                                              className="btn btn-primary"
                                            >
                                              Pay
                                            </button>
                                          </div>
                                        );
                                      },
                                    });
                                  }}
                                  className="btn btn-primary"
                                >
                                  Pay to delivery boy
                                </button>

                                {!is_accountant_only && (
                                  <>
                                <div className="card-header mb-2">
                                  <h4 className="card-title">
                                    Order acceptance limit
                                  </h4>
                                </div>

                                <div className="basic-form mb-2">
                                  <form>
                                    <div className="form-row mb-2">
                                      <div className="form-group col-md-12">
                                        <label>Order limit</label>
                                        <input
                                          type="number"
                                          min={0}
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-" ||
                                              evt.key === ".") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          value={data.deliveryboy_limit}
                                          onChange={(e) => {
                                            setData({
                                              ...data,
                                              deliveryboy_limit: e.target.value,
                                            });
                                          }}
                                          className="form-control"
                                        />
                                      </div>
                                    </div>
                                  </form>
                                </div>

                                <button
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (!data.deliveryboy_limit) {
                                      showMessage(
                                        "Please enter a limit",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    var fdata = new FormData();
                                    fdata.append(
                                      "keyword",
                                      "delivery_boy_limit"
                                    );
                                    fdata.append("del_id", data.id);
                                    fdata.append(
                                      "delivery_limit",
                                      data.deliveryboy_limit
                                    );

                                    var config = {
                                      method: "patch",
                                      url: url + "/delivery/dbdetails/",
                                      headers: {
                                        Authorization: token,
                                      },
                                      data: fdata,
                                    };

                                    axios(config)
                                      .then(function (response) {
                                        if (response.data.Status) {
                                          showMessage(
                                            "Order limit updated",
                                            "success",
                                            "Success!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                        } else {
                                          showMessage(
                                            "Order limit update failed",
                                            "danger",
                                            "Failed!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                        }
                                      })
                                      .catch(function (error) {
                                        showMessage(
                                          "Order limit update failed",
                                          "danger",
                                          "Failed!",
                                          "top",
                                          "top-right",
                                          0
                                        );
                                      });
                                  }}
                                  className="btn btn-primary"
                                >
                                  Update
                                </button>

                                <div className="card-header mb-2">
                                  <h4 className="card-title">
                                    Cash in hand limit
                                  </h4>
                                </div>

                                <div className="basic-form mb-2">
                                  <div className="form-row mb-2">
                                    <div className="form-group col-md-12">
                                      <label>Cash limit (Rs)</label>
                                      <input
                                        type="number"
                                        min={1}
                                        step={1}
                                        placeholder="No limit"
                                        onKeyDown={(evt) =>
                                          ((evt.key === "e" ||
                                            evt.key === "-" ||
                                            evt.key === ".") &&
                                            evt.preventDefault()) ||
                                          (evt.key === "E" &&
                                            evt.preventDefault())
                                        }
                                        onWheelCapture={(e) => {
                                          e.target.blur();
                                        }}
                                        value={data.cod_limit}
                                        onChange={(e) => {
                                          setData({
                                            ...data,
                                            cod_limit: e.target.value,
                                          });
                                        }}
                                        className="form-control"
                                      />
                                      <small className="form-text text-muted">
                                        Cash in hand now: Rs{" "}
                                        {Number(data.cash_in_hand || 0).toFixed(0)}.
                                        Once the rider holds this much, they cannot
                                        accept new orders until they submit cash.
                                        Leave blank for no limit.
                                      </small>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const value = String(data.cod_limit ?? "").trim();
                                    if (value !== "" && !(Number(value) > 0)) {
                                      showMessage(
                                        "Enter an amount above zero, or leave blank for no limit",
                                        "danger",
                                        "Error!",
                                        "top",
                                        "top-right",
                                        0
                                      );
                                      return;
                                    }

                                    var fdata = new FormData();
                                    fdata.append("keyword", "cod_limit");
                                    fdata.append("del_id", data.id);
                                    fdata.append("cod_limit", value);

                                    var config = {
                                      method: "patch",
                                      url: url + "/delivery/dbdetails/",
                                      headers: {
                                        Authorization: token,
                                      },
                                      data: fdata,
                                    };

                                    axios(config)
                                      .then(function (response) {
                                        if (response.data.Status === true) {
                                          showMessage(
                                            value === ""
                                              ? "Cash limit removed"
                                              : "Cash limit updated",
                                            "success",
                                            "Success!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                        } else {
                                          showMessage(
                                            response.data.Error ||
                                              "Cash limit update failed",
                                            "danger",
                                            "Failed!",
                                            "top",
                                            "top-right",
                                            0
                                          );
                                        }
                                      })
                                      .catch(function (error) {
                                        showMessage(
                                          error.response?.data?.Error ||
                                            "Cash limit update failed",
                                          "danger",
                                          "Failed!",
                                          "top",
                                          "top-right",
                                          0
                                        );
                                      });
                                  }}
                                  className="btn btn-primary"
                                >
                                  Update cash limit
                                </button>
                                  </>
                                )}
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* for comments */}
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="post-details">
                            <h3 className="mb-2 text-black">Comments</h3>
                            <div>
                              {" "}
                              {reviews.length > 0 ? (
                                <div className="card-body p-0">
                                  {reviews.map((item) => {
                                    return (
                                      <CommentListingDelivery review={item} />
                                    );
                                  })}{" "}
                                </div>
                              ) : (
                                <div className="card-body p-0">
                                  No Comments found
                                </div>
                              )}{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <RiderReport riderId={id} />
                </>

                <div className="col-xl-12 col-lg-12"></div>
              </>
            ) : (
              <NoDataComponent data="Delivery boy " />
            )
          ) : (
            <LoadingComponent />
          )}
        </div>
      </div>
    </div>
  );
}

function DeliveryBoy() {
  const headers = "Delivery Boy Details";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default DeliveryBoy;
